import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getEvents, updateEvent } from "../../store/slice/eventSlice";
import { SidebarComponent } from "../../helpers/commonFunction";

const DeleteEvent = ({
  show,
  serviceDetail,
  handleClose,
  setDeleteModal,
  setDeleteModalId,
  page_number,
  values,
}) => {
  const dispatch = useDispatch();
  const showHideClassName = show && "user_detail_modal_show";
  const { t } = useTranslation("common");
  const sideHeading = localStorage.getItem("sidebar_component");

  const deleteEventHandler = () => {
    const data = {
      delete_status: "1",
    };
    dispatch(
      updateEvent({
        data,
        id: serviceDetail,
        isDelete: true,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            dispatch(
              getEvents({
                start: (page_number - 1) * 10,
                title: values.title,
                address: values.address,
                date: values.date && moment(values.date).format("YYYY-MM-DD"),
              })
            );
            setDeleteModal(false);
            setDeleteModalId("");
          }
        },
        toast: t("toast.delete_event"),
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            Delete {SidebarComponent()}
            {/* {sideHeading} */}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.deleteEventDesc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deleteEventHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteEvent;
